import { render, staticRenderFns } from "./FacialDevicePage.vue?vue&type=template&id=6b3649d1&scoped=true&"
import script from "./FacialDevicePage.vue?vue&type=script&lang=js&"
export * from "./FacialDevicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3649d1",
  null
  
)

export default component.exports